import React from 'react';
import { useTranslation } from 'react-i18next';

import activationImage from '@/assets/working.png';

export type ActivationScreenContainerProps = {
  title: React.ReactNode | string;
  description: React.ReactNode | string;
};

export const ActivationScreenContainer = ({
  title,
  description,
}: ActivationScreenContainerProps) => {
  const { t } = useTranslation();

  const getHeader = (image: string) => {
    return <img alt={t('ActivationScreen.imageAlt')} src={image} width="470" />;
  };

  return (
    <div className="max-w-xl mt-6 mb-6 m-auto h-screen flex items-center justify-center min-h-[500px]">
      <div className="flex flex-wrap items-center justify-center">
        <div className="text-4xl mb-5 text-center text-md-blue">{title}</div>
        <p className="mb-0 flex items-center justify-center">{getHeader(activationImage)}</p>
        <div className="text-3xl mt-5 text-center font-secondary text-md-blue">{description}</div>
      </div>
    </div>
  );
};
